export const getContentTagForDisplay = (contentType: string) => {
  // API response references:
  // catalog: "CodingChallenge", "CtfChallenge", "HandsOnLesson"
  // admin paths: "coding_challenge", "hacking_challenge", "breakfix"
  // lesson view: "code_challenge", "hacking_challenge", "lesson", "app_lab"

  switch (contentType) {
    case "breakfix":
    case "lesson":
      return "Break/Fix";
    case "code_challenge":
    case "coding_challenge":
    case "codingChallenge":
      return "Coding_Challenge";
    case "hacking_challenge":
    case "ctfChallenge":
    case "hackingChallenge":
      return "Ctf_Challenge";
    case "appLab":
    case "app_lab":
      return "App_Lab";
    default:
      return contentType;
  }
};
